<!-- Delete Folder Modal -->
<div class="modal-content">
    <div class="modal-body">
        <div class="fc_modal_body">          
            <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="activeModal.close()"></button>
            <h3 class="h3">Are you sure you want to delete <span class="folder_message"> {{info?.name}} </span> folder?</h3>
            <div class="form-group d-flex justify-content-between align-items-center mb-0">
                <button type="button" class="border_btn" data-bs-dismiss="modal" (click)="activeModal.close()">Cancel</button>
                <button type="submit" class="primary_btn" (click)="Delete()">Confirm</button>
            </div>
        </div>
    </div>
</div>